module.exports = __webpack_public_path__ + "img/pen.a89d8eca.svg";